import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../../common/Pagination';
import { getNavIconClass } from '../../../../navigation/clinicNavConfig';
import { getReputationAvatarTheme } from '../subparts/reputationTheme';
import {
    formatReputationDate,
    getFeedbackMeta,
    getNameInitials,
} from '../subparts/reputationQuery';

function FeedbackTab({ patientFeedbacks, onPageChange }) {
    const [currentPage, setCurrentPage] = useState(0);
    const feedbacks = patientFeedbacks?.content || [];
    const totalElements = patientFeedbacks?.totalElements ?? 0;

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };

    return (
        <div className="h-100 d-flex flex-column min-h-0">
            <div className="reputation-toolbar">
                <div>
                    <h2 className="reputation-toolbar__title">Patient Feedback</h2>
                    <p className="reputation-toolbar__subtitle mb-0">
                        Sentiment collected from your reputation page
                    </p>
                </div>
                <span className="reputation-toolbar__summary">
                    {totalElements} response{totalElements === 1 ? '' : 's'}
                </span>
            </div>

            <div className="reputation-tab-content">
                {feedbacks.length > 0 ? (
                    <>
                        <div className="table-responsive reputation-table-wrap">
                            <table className="table table-hover align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th>Patient</th>
                                        <th>Feedback</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {feedbacks.map((feedback, index) => {
                                        const feedbackMeta = getFeedbackMeta(feedback.feedback);

                                        return (
                                            <tr key={feedback.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <span
                                                            className={`reputation-avatar ecx-nav-icon ${getNavIconClass(
                                                                getReputationAvatarTheme(feedback.id, index)
                                                            )}`}
                                                        >
                                                            {getNameInitials(feedback.patientName)}
                                                        </span>
                                                        {feedback.patientId ? (
                                                            <Link
                                                                to={`/patient-files/${feedback.patientId}`}
                                                                className="reputation-patient-link fw-normal"
                                                            >
                                                                {feedback.patientName}
                                                            </Link>
                                                        ) : (
                                                            <span className="fw-normal text-dark">
                                                                {feedback.patientName}
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className={feedbackMeta.className}>
                                                        <i className={`bi ${feedbackMeta.icon}`}></i>
                                                        {feedbackMeta.label}
                                                    </span>
                                                </td>
                                                <td className="text-muted small">
                                                    {formatReputationDate(feedback.createdAt)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {patientFeedbacks.totalPages > 1 && (
                            <div className="reputation-pagination">
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={patientFeedbacks.totalPages}
                                    onPageChange={handlePageChange}
                                    totalElements={totalElements}
                                    pageSize={patientFeedbacks.pageable?.pageSize || 10}
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <div className="reputation-empty">
                        <div className="reputation-empty__icon" aria-hidden="true">
                            <i className="bi bi-emoji-smile"></i>
                        </div>
                        <h3 className="h6 fw-normal text-dark mb-1">No patient feedback</h3>
                        <p className="mb-0 small text-muted">
                            Patient feedback will appear here once reviews are submitted.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default FeedbackTab;
